import {
    resetCouponFields,
    resetToBasePrice,
    showLoadingSpinner,
    disableCouponField,
    userHasPromotionSelected,
    removeDiscountLabel,
    getAppliedPromotionCouponCode,
    handleCheckoutButton,
    ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS,
    ORDER_SUMMARY_DISCOUNT_LABEL_CLASS,
    ORDER_SUMMARY_DISCOUNT_PRICE_CLASS,
    ORDER_SUMMARY_DISCOUNT_DISCOUNT_JS,
    TEXT_ERROR,
    APPLY_COUPON_JS,
    CART_SUMMARY_COUPON_FIELD_CLASS,
    APPLIED_COUPON_FIELD_INPUT,
    TOTAL_COST_FOR_AD_PRICE,
    ORDER_SUMMARY_DISCOUNT_MESSAGE_CLASS,
    IS_COUPON_AUTO_APPLIED,
    CART_SUMMARY_NEXT_BILLING_DATE_JS,
} from "./cart_summary_helpers";

import {
    userHasSubscribeAndSaveSelected,
    isSubscribeAndSaveCouponCode,
} from "./subscribe-and-save";

import { GetUrlContextParametersString } from "./helpers.js";

var couponRequest = null;

function abortCouponRequest() {
    if (couponRequest) {
        couponRequest.abort();
        couponRequest = null;
    }
}

export function validateCoupon(target, hs_applied_coupon = null) {
    handleCheckoutButton(false, "couponRequest");

    let formName = jQuery(target).attr("data-form");
    var formData = jQuery("form[name=" + formName + "]").serializeArray();

    if (hs_applied_coupon) {
        formData = [...formData, { name: "coupon", value: hs_applied_coupon }];
    }

    abortCouponRequest();

    couponRequest = jQuery
        .post(getCouponControllerEndpointDetails("apply_coupon"), formData)
        .success(function (response) {
            handleCheckoutButton(true, "couponRequest");

            var data = jQuery.parseJSON(response);
            const {
                cost,
                product_cost,
                savings,
                valid,
                notValidReason,
                code,
                successMessage,
                couponBalance,
                raw_product_cost,
                discount,
                raw_savings,
                max_redeemable_cents_per_boost_customer,
                next_billing_date,
            } = data;

            if (!valid) {
                jQuery(APPLY_COUPON_JS).attr(
                    "src",
                    "/homespotter/darwin/images/error_exclamation.svg"
                );

                jQuery(TEXT_ERROR).text(notValidReason);
                jQuery(TEXT_ERROR).show();
            }

            if (valid) {
                jQuery(APPLY_COUPON_JS).attr(
                    "src",
                    "/homespotter/darwin/images/success.svg"
                );

                jQuery(TOTAL_COST_FOR_AD_PRICE).text(product_cost);
                jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).text(cost);
                jQuery(ORDER_SUMMARY_DISCOUNT_PRICE_CLASS).text(savings);
                if (next_billing_date.length > 0) {
                    jQuery(CART_SUMMARY_NEXT_BILLING_DATE_JS).text(
                        next_billing_date
                    );
                }
                if (
                    couponBalance !== null &&
                    couponBalance - raw_savings <= 0 &&
                    max_redeemable_cents_per_boost_customer
                ) {
                    jQuery(ORDER_SUMMARY_DISCOUNT_MESSAGE_CLASS).text(
                        "co-marketing credit limit reached"
                    );
                }

                let displayMessage = "Coupon Applied: " + code;
                if (successMessage !== "" && successMessage !== null) {
                    let savings_percent = Math.floor(
                        (raw_savings * 100) / raw_product_cost
                    );
                    displayMessage = successMessage.replace(
                        "{{percent_savings}}",
                        savings_percent
                    );
                }

                jQuery(ORDER_SUMMARY_DISCOUNT_LABEL_CLASS).text(displayMessage);
                jQuery(ORDER_SUMMARY_DISCOUNT_DISCOUNT_JS).show();
                jQuery(APPLIED_COUPON_FIELD_INPUT).val(code);
            }
        });

    return couponRequest;
}

export function clearCouponFromCart() {
    handleCheckoutButton(false, "couponRequest");
    let endpoint = getCouponControllerEndpointDetails("clear_coupon");

    abortCouponRequest();

    couponRequest = jQuery.post(endpoint).success(function (response) {
        handleCheckoutButton(true, "couponRequest");
        var data = jQuery.parseJSON(response);
        const { product_cost, next_billing_date } = data;

        removeDiscountLabel();
        jQuery(APPLY_COUPON_JS).attr(
            "src",
            "/homespotter/darwin/images/right-arrow.svg"
        );

        jQuery(TOTAL_COST_FOR_AD_PRICE).text(product_cost);
        jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).text(product_cost);

        if (next_billing_date.length > 0) {
            jQuery(CART_SUMMARY_NEXT_BILLING_DATE_JS).text(next_billing_date);
        }
    });
    return couponRequest;
}

function getCouponControllerEndpointDetails(dest) {
    let cartId = jQuery('input[name="cartId"]').val();
    let shortcode = jQuery('input[name="shortcode"]').val();
    let campaignType = jQuery('input[name="campaign_type"]').val();
    const isNonListing =
        campaignType === "AgentPromo" || campaignType === "Recruiting";
    let controller = isNonListing ? "non_listing_cart" : "boost_cart";
    var context = GetUrlContextParametersString();

    let endpoint =
        "/dashboard/" +
        controller +
        "/" +
        dest +
        "/" +
        shortcode +
        "/" +
        cartId +
        "?" +
        context;
    return endpoint;
}

export default function ApplyCouponSubmitButtonEvent() {
    jQuery(APPLY_COUPON_JS).click((event) => {
        event.preventDefault();

        jQuery(TEXT_ERROR).hide();
        resetToBasePrice();
        removeDiscountLabel();

        jQuery(APPLY_COUPON_JS).attr(
            "src",
            "/homespotter/darwin/images/right-arrow.svg"
        );

        let couponCode = jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).val();
        if (!couponCode || couponCode === "") {
            resetCouponFields();
            return;
        }

        showLoadingSpinner();

        validateCoupon(event.currentTarget);
    });
}

export const applyPromotion = (coupon, callback = null) => {
    showLoadingSpinner();
    return validateCoupon(jQuery(APPLY_COUPON_JS), coupon).then((res) => {
        var data = jQuery.parseJSON(res);

        if (callback) {
            callback(data);
        } else {
            const { valid, succesMessage, code } = data;
            if (valid) {
                jQuery(ORDER_SUMMARY_DISCOUNT_LABEL_CLASS).text(succesMessage);
                jQuery(APPLY_COUPON_JS).attr(
                    "src",
                    "/homespotter/darwin/images/success.svg"
                );

                if (userHasPromotionSelected()) {
                    disableCouponField();
                } else {
                    jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).val(code);
                }
            } else {
                jQuery(IS_COUPON_AUTO_APPLIED).val(0);
                resetCouponFields();
                resetToBasePrice();
            }
        }

        return data;
    });
};

$(document).ready(() => {
    let coupon = getAppliedPromotionCouponCode();

    // user must have refreshed the page or something, the SS ui always starts fresh - remove the coupon
    if (isSubscribeAndSaveCouponCode(coupon)) {
        resetCouponFields();
        clearCouponFromCart();
        return;
    }
    // We don't want to run applyPromotion if sub and save is selected, its all handled by the client code.
    if (userHasSubscribeAndSaveSelected()) {
        return;
    }

    if (coupon && coupon !== "") {
        applyPromotion(coupon);
    }
});
